// ? Style
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing:border-box;

  }

  html{
    &::-webkit-scrollbar{
      width:0.5rem;
    }
    &::-webkit-scrollbar-thumb{
      background-color:darkgray
    }
  }
  body{
    font-family: 'Montserrat', sans-serif;
    width:100%;
    background-color: rgba(42, 42, 42, 1);
    color: #fff
  }

  h2{
    font-size:3rem;
    font-family: 'Abril Fatface', cursive;
    font-weight:lighter;
    color: #fff;

  }

  h3{
    font-size:1.5rem;
    color: #333;
    padding:1.2rem 0rem;
    color: #fff;
  }

  h4{
    color:#ccc;
  }

  button{
    color:#ccc;
  }

  p{
    font-size:1.2rem;
    line-height:200%;
    color: #fff;
  }

  a{
    text-decoration:none;
    color: #fff;
  }
  img{
    display:block;
  }

  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1500px;
  }

  a{
    text-decoration:none;
  }

  a:hover{
    text-decoration:none;
    color: #fff
  }

  .list_group_links {
    background-color: rgba(54, 54, 54, 1);
    p{
      cursor:pointer;
      padding: 0;
      margin:0;
      color:#ccc;
    }
  }
  .loader {
    display:flex;
    justify-content: center;
    align-items: center;
  }
`;

export default GlobalStyles;
